import { Button } from '@components/common/button';
import { Modal } from '@components/common/modal';
import ModalInner from '@components/common/modal/ModalInner';
import ModalContent from '@components/common/modal/ModalContent';
import ModalActions from '@components/common/modal/ModalActions';
import ModalTitle from '@components/common/modal/ModalTitle';
import CloseModalButton from '@components/common/modal/CloseModalButton';
import { Spacing } from '@components/common/styles';

export type EmbedMediaModalPropsType = {
  title?: string | React.ReactElement;
  content?: string;
  submitLabel?: string;
  cancelLabel?: string;
  onClickSubmit?: Function;
  onClickCancel?: Function;
  onClose: Function;
  onClickClose?: Function;
  children?: React.ReactChild;
};

const EmbedMediaModal = ({
  title,
  content,
  submitLabel,
  cancelLabel,
  onClickSubmit,
  onClickCancel,
  onClose,
  onClickClose,
  children,
}: EmbedMediaModalPropsType) => {
  const handleClickCancel = () => {
    onClickCancel && onClickCancel();
    onClose();
  };

  const handleClickSubmit = () => {
    onClickSubmit && onClickSubmit();
    onClose();
  };

  const handleClickClose = () => {
    onClickClose && onClickClose();
    onClose();
  };
  return (
    <Modal onClickClose={onClickClose} onClose={onClose}>
      <ModalInner>
        <div className="w-[340px]">
          <div className="relative">
            <ModalTitle>{title}</ModalTitle>
            <div className="absolute top-[0] right-[0]">
              <CloseModalButton onClose={handleClickClose} />
            </div>
          </div>

          <ModalContent>{content}</ModalContent>
          <Spacing size={20} />
          {children}
          <ModalActions justify="right">
            <div className="min-w-[88px]">
              <Button
                shape="pill"
                size="medium"
                color="outline"
                fullWidth
                onClick={handleClickCancel}
              >
                {cancelLabel || '취소'}
              </Button>
            </div>
            <div className="ml-[16px] min-w-[88px]">
              <Button
                shape="pill"
                size="medium"
                color="primary"
                fullWidth
                onClick={handleClickSubmit}
              >
                {submitLabel || '확인'}
              </Button>
            </div>
          </ModalActions>
        </div>
      </ModalInner>
    </Modal>
  );
};

export default EmbedMediaModal;
